import React  from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import InputLabelCustom from '../../../shared/components/forms/InputLabelCustom';
import { finderSpecialityByName } from '../../../shared/global/helpers';
import { daysAvailableState, filterSearchSelectedState, isChangeFormSearchState } from '../../state/atoms';
import { dayDefaultAvailableState } from '../calendars/state/atoms';
import { specialitiesState } from './state/atoms';

const AutocompleteSpecialities = ({ size = "small", styles }) => {
    const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
    const specialities = useRecoilValue(specialitiesState);
    const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(filterSearchSelectedState);
    const resetDayDefaultAvailable = useResetRecoilState(dayDefaultAvailableState);
    const resetDaysAvailable = useResetRecoilState(daysAvailableState);

    return (
        <>
            <InputLabelCustom htmlFor="autocomplete-especialidad" text="Especialidad" style={{ ...styles.label }} />
            <Autocomplete
                style={{ ...styles.autocomplete }}
                size={size}
                id="autocomplete-especialidad"
                options={specialities.map((option) => `${option.espNombre}`)}
                getOptionLabel={option => option || null}
                value={filterSearchSelected.specialitySelected.value || null}
                noOptionsText="Sin resultados"
                onChange={(event, value, reason) => {
                    setIsChangeFormSearch(true);
                    resetDayDefaultAvailable();
                    resetDaysAvailable();
                    if (reason === 'clear') {
                        setFilterSearchSelected({
                            ...filterSearchSelected,
                            specialitySelected: {
                                ...filterSearchSelected.specialitySelected,
                                value: '',
                                code: null
                            },
                            professionalSelected: {
                                ...filterSearchSelected.professionalSelected,
                                value: '',
                                code: null
                            }
                        })

                        return;
                    }

                    if (reason === 'selectOption') {
                        const findSpeciality = finderSpecialityByName(specialities, value);
                        setFilterSearchSelected({
                            ...filterSearchSelected,
                            specialitySelected: {
                                ...filterSearchSelected.specialitySelected,
                                value: value,
                                code: findSpeciality?.esCodigo
                            },
                            professionalSelected: {
                                ...filterSearchSelected.professionalSelected,
                                value: '',
                                code: null
                            }
                        })
                    }
                }}
                renderInput={(params) => <TextField {...params} placeholder="Buscar" variant="outlined" />}
            />
        </>
    )
}

export default AutocompleteSpecialities
